import React, { memo } from 'react';
import { Progress } from 'app/shared/components';
import { useFileUploadAnswer, useShowFileUploadAnswer } from './hooks';
import Uploader from './Uploader';
import FileBlock from './FileBlock';
import { useStyles } from './styles';

function Answer() {
  const { fileName, percentage, onChange, onRemove } = useFileUploadAnswer();
  const styles = useStyles();

  if (percentage === 0) {
    return <Uploader onChange={onChange} />;
  } else if (percentage === 100) {
    return <FileBlock fileName={fileName} onRemove={onRemove} />;
  }

  return (
    <div className={styles.fileUploadProgress}>
      <Progress percentage={percentage} />
    </div>
  );
}

function AnswerContainer() {
  const show = useShowFileUploadAnswer();

  if (show) {
    return <Answer />;
  }

  return null;
}

export default memo(AnswerContainer);
